import { useMutation } from "@tanstack/react-query";
import { useFormSuccessNotification, useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import type { CreateShopOverrideRuleDto, ShopOverrideRuleDto } from "../generated/schema";

interface UseCreateShopOverrideRuleParams {
	onSuccess?: (data: ShopOverrideRuleDto[]) => void;
}

export default function useCreateShopOverrideRule(
	shopId: string,
	options?: UseCreateShopOverrideRuleParams,
) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();

	const mutation = $api.useMutation("post", "/shops/{shopId}/override-rules");

	return useMutation({
		onSuccess: (data) => {
			successNotification();
			return options?.onSuccess?.(data);
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: async (requestBody: CreateShopOverrideRuleDto) => {
			return mutation.mutateAsync({
				params: { path: { shopId } },
				body: requestBody,
			});
		},
	});
}